import { TYPE_COLLECTION } from './input-types';

export const id = 'state';
export const apiKey = 'shipToState';
export const type = TYPE_COLLECTION;

export const state = {
  id,
  apiKey,
  type,
};
